/* The Jira project the Requirement Board and the Artifacts screen open on when
   nothing else is chosen: PSR, or the first project Jira lists when PSR is not
   among them. */
export const DEFAULT_PROJECT = "PSR";

export function defaultProjectOf(list) {
  if (!Array.isArray(list) || !list.length) return "";
  const psr = list.find((p) => String(p?.key || "").toUpperCase() === DEFAULT_PROJECT);
  return (psr || list[0]).key;
}
